<template>
  <div class="topRouge" id="reseauxLc" v-if="detailReseauxLcFilter.length">
    <p class="p_size18 has-text-weight-bold has-text-link bottomVert">
      <b-icon
        icon="circle"
        size="is-small"
        class="circleStyleMobile">
      </b-icon>
      Proposition réseau(x) LC
    </p>
    <div class="colomn"
      v-for="(reseauxLc, index) in detailReseauxLcFilter"
      :key="index">
      <h3 class="has-text-default has-text-weight-bold topBleu bottomVert">
        {{reseauxLc.libelle}}
      </h3>
      <app-carte-reseaux-lc :detailReseauxLc="reseauxLc"
      :markerReseauxLc="markerReseauxLc"/>
      <app-info-reseaux-lc :infoReseauxLc="reseauxLc"/>
    </div>
  </div>
</template>

<script>
import { iconColorGetter, TAILLE_ICON_GRAND } from '@/services/general/iconColorGetter';
import carteReseauxLc from './carteReseauxLc';
import infoReseauxLc from './infoReseauxLc';

export default {
  name: 'index',
  props: ['detailReseauxLc', 'adresseReseauxLc'],
  components: {
    appCarteReseauxLc: carteReseauxLc,
    appInfoReseauxLc: infoReseauxLc,
  },
  data() {
    return {
      markerReseauxLc: {},
    };
  },
  computed: {
    detailReseauxLcFilter() {
      return this.detailReseauxLc.filter(d => !d.extensionOpportunite.reseauPersoGuid);
    },
  },
  methods: {
    generateMarker() {
      if (this.adresseReseauxLc.lat !== undefined) {
        this.markerReseauxLc = {
          ...this.adresseReseauxLc,
          icon: iconColorGetter('#000000', TAILLE_ICON_GRAND, null, false),
        };
      }
    },
  },
  mounted() {
    this.generateMarker();
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/opportuniteClient/ismobile/propositions/reseauxLc/index.vue